import { collection, getDocs } from "firebase/firestore";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { db } from "../../firebase";
import Header from "../../layout/header/header";

const ServicesList = () => {
  const [services, setServices] = useState([]);

  const fetchServices = async () => {
    const querySnapshot = await getDocs(collection(db, "services"));
    let mServices = [];
    querySnapshot.forEach((doc) => {
      mServices.push({ id: doc.id, ...doc.data() });
    });
    console.log("SERVICES:", mServices);
    setServices(mServices);
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return (
    <div>
      <div className="home_main">
        <Header />
        {/* <!-- salon for men --> */}
        <section className="salon_for_main" style={{ margin: "6rem auto" }}>
          Select a Service to Continue
          <div className="container-fluid">
            <div className="salon_men_inr">
              <ul>
                {services.length
                  ? services.map((mService) => (
                      <Link to={`/services/${mService.id}`} key={mService.id}>
                        <li>
                          <div className="salon_col">
                            <img
                              alt=""
                              className="img-fluid"
                              src={mService.icon}
                            />
                            <h4>{mService.name}</h4>
                          </div>
                        </li>
                      </Link>
                    ))
                  : "Loading"}
              </ul>
            </div>
          </div>
        </section>
        {/* <!-- salon for men --> */}
      </div>
    </div>
  );
};

export default ServicesList;
